import { render } from "./GEditTemplateCard.vue?vue&type=template&id=933e64e6&scoped=true"
import script from "./GEditTemplateCard.vue?vue&type=script&lang=js"
export * from "./GEditTemplateCard.vue?vue&type=script&lang=js"

import "./GEditTemplateCard.vue?vue&type=style&index=0&id=933e64e6&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-933e64e6"]])

export default __exports__